import { FaLaptopCode, FaBuilding, FaBalanceScaleRight, FaGavel, FaUniversity } from 'react-icons/fa';

export const timelineData = [
    {
        id: 1,
        icon: FaLaptopCode,
        title: 'Lead Developer',
        period: 'Jun 2023 - Present',
        year: 'NOW',
        descriptionBefore: 'Lead Developer at ',
        descriptionAfter:
            ", a partner of Destroyed Secure. I lead development across all of Uptrust's web projects — websites, platforms, and client applications — owning architecture, implementation, and delivery while strengthening the security of every product we ship.",
        link: {
            text: 'Uptrust Cybersec',
            url: 'https://uptrust.eu',
        },
    },
    {
        id: 2,
        icon: FaBuilding,
        title: 'Founded Destroyed Secure',
        period: 'Jun 2023 - Present',
        year: '2023',
        descriptionBefore: 'Founder of ',
        descriptionAfter:
            ", a certified data destruction company. I'm primarily responsible for the secure data-destruction procedures — degaussing and mechanical shredding of HDDs, SSDs, tapes, and other storage media — following NIST 800-88 and DIN 66399 standards, with video-documented processes and GDPR-compliant certificates of destruction.",
        link: {
            text: 'Destroyed Secure',
            url: 'https://destroyedsecure.ro',
        },
    },
    {
        id: 3,
        icon: FaBalanceScaleRight,
        title: 'Attorney at Law',
        period: 'Dec 2022 - Jun 2023',
        year: '2022',
        description: 'Drafted legal documents, provided legal consultancy, and facilitated negotiations. I also began self-learning programming. I completed the CS50 course from Harvard, followed by learning Python. I built small projects and acquired foundational programming skills.',
        link: null,
    },
    {
        id: 4,
        icon: FaGavel,
        title: 'Junior Lawyer',
        period: 'Sept 2020 - Dec 2022',
        year: '2020',
        description: 'I started my journey as a Junior Lawyer at SCA Laura Elena Chiorean & Asociații. While learning some of the basics practices of law, i decided i need better practicioneres so i moved to Benedeck where i finished my period as a Junior Lawyer. During my tenure as a junior lawyer at Benedeck, I was privileged to immerse myself in the intricate world of business law, spanning areas such as tax law, contract drafting, privacy, and administrative/labor law. This esteemed firm, recognized for its impeccable legal consultancy for clients in the IT, real estate, production, and transportation sectors, provided me with a comprehensive foundation.',
        link: null,
    },
    {
        id: 5,
        icon: FaUniversity,
        title: 'University of Law',
        period: '2015 - 2019',
        year: '2015',
        description: 'Babeș Bolyai University, Cluj-Napoca',
        link: null,
    },
];
